import { render, staticRenderFns } from "./Etape2.vue?vue&type=template&id=4c6c6d4e"
import script from "./Etape2.vue?vue&type=script&lang=js"
export * from "./Etape2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports